import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material"
import { useFormik } from "formik"
import Dropzone from "react-dropzone"
import * as yup from "yup"
import FileIcon from "../../components/Icons/FileIcon"

const ContractUploadForm = ({ data, open, onClose, onSubmit }) => {

    const { values, handleSubmit, setFieldValue } = useFormik({
        initialValues: { id: data?.id },
        enableReinitialize: true,
        validationSchema: yup.object({
            file: yup.mixed().nonNullable()
        }),
        onSubmit: onSubmit
    })

    if (!open || !values) return null

    return <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
        <DialogTitle>Загрузка договора</DialogTitle>
        <DialogContent>
            <Dropzone
                onDrop={files => setFieldValue("file", files[0])}
                maxSize={1024 * 1024 * 5}
                accept={{
                    "image/jpeg": [],
                    "image/png": [],
                    "application/pdf": [],
                }}
                noDragEventsBubbling
                maxFiles={1}
                multiple={false}
            >
                {({ getRootProps, getInputProps }) => {

                    const { onClick, ...rootProps } = getRootProps()

                    return <Box
                        {...rootProps}
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#E8F2FF",
                            borderRadius: "5px",
                            borderColor: "primary",
                            mt: 2, mb: 2, p: 1,
                            minHeight: 120
                        }}
                    >
                        <Box
                            sx={{
                                p: 1,
                                display: "flex",
                                flexWrap: "wrap",
                            }}
                        >
                            {!values.file ? (
                                <Typography align="center" sx={{ m: 1 }}>
                                    Перетащите файл сюда или загрузите вручную. Допустимые форматы: pdf, png и jpg, размером не более 5Мб
                                </Typography>
                            ) : <FileIcon
                                name={values.file.name}
                                type={values.file.type}
                                onDelete={() => setFieldValue("file", null)}
                            />}
                        </Box>

                        <Button sx={{ height: 35 }} variant="contained" onClick={onClick}>
                            Выбрать файл
                        </Button>

                        <input {...getInputProps()} />
                    </Box>
                }}
            </Dropzone>
        </DialogContent>
        <DialogActions>
            <Button onClick={handleSubmit}>
                Загрузить
            </Button>
            <Button color="error" onClick={onClose}>
                Отмена
            </Button>
        </DialogActions>
    </Dialog>

}

export default ContractUploadForm
